import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputNumbersmall, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { cuttingReturnEntry, fetchCuttingList } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { selectCuttingDatalist } from '../Selectors/Master/ItemSelectors';
import { useParams } from 'react-router-dom';
import { errorStyles } from '../../Utils/table';


const CuttingInward = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        cutId: parseInt(Id),
        dt: '',
        reMemo: '',
        cutMemo: '',
        sono: '',
        soId: '',
        empNm: '',
        empType: '1',
        item: '',
        itemId: '',
        mcloth: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        mgmtr: '',
        m1gmtr: '',
        m2gmtr: '',
        m3gmtr: '',
        mRmtr: '',
        m1Rmtr: '',
        m2Rmtr: '',
        m3Rmtr: '',
        mused: '0',
        m1used: '0',
        m2used: '0',
        m3used: '0',
        totQty: '0',
        reQty: '0',
        userId: '1',
    });
    const [errors, setErrors] = useState({});

    const dispatch = useDispatch();
    const cuttingdatalist = useSelector(selectCuttingDatalist);

    var itemData = cuttingdatalist.cuttingInfo2.length > 0 ? {
        size: cuttingdatalist.cuttingInfo2.map(val => val.size),
        mavg: cuttingdatalist.cuttingInfo2.map(val => parseFloat(val.mavg)),
        m1avg: cuttingdatalist.cuttingInfo2.map(val => parseFloat(val.m1avg)),
        m2avg: cuttingdatalist.cuttingInfo2.map(val => parseFloat(val.m2avg)),
        m3avg: cuttingdatalist.cuttingInfo2.map(val => parseFloat(val.m3avg)),
        qty: cuttingdatalist.cuttingInfo2.map(val => parseFloat(val.balqty)),
        soqty: cuttingdatalist.cuttingInfo2.map(val => parseFloat(val.soqty))
    } : [];
    const [extraQtyValues, setExtraQtyValues] = useState(Array(itemData.size?.length).fill(''));
    const [returnQtyValues, setReturnQtyValues] = useState(Array(itemData.size?.length).fill(''));
    const [damageQtyValues, setDamageQtyValues] = useState(Array(itemData.size?.length).fill(''));
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData.size?.length).fill(''));
    const [mainAvg, setMainAvg] = useState(Array(itemData.size?.length).fill(''));
    const [m1Avg, setM1Avg] = useState(Array(itemData.size?.length).fill(''));
    const [m2Avg, setM2Avg] = useState(Array(itemData.size?.length).fill(''));
    const [m3Avg, setM3Avg] = useState(Array(itemData.size?.length).fill(''));


    useEffect(() => {
        dispatch(fetchCuttingList(Id));
    }, [dispatch, Id]);
    useEffect(() => {
        if (cuttingdatalist.data && cuttingdatalist.data.length > 0) {
            const item = cuttingdatalist.data[0];
            const returncount = parseFloat(cuttingdatalist.countId) + 1;
            setFormData(prev => ({
                ...prev,
                empNm: item.empNm,
                empId: item.empId,
                empType: item.empType,
                item: item.itemNm,
                itemId: item.itemId,
                cutMemo: item.memoNo,
                reMemo: returncount !== 1 ? `R-${item.memoNo}-${returncount}` : `R-${item.memoNo}`,
                soId: item.soId,
                sono: item.sono,
                totQty: item.totQty,

            }));

        }
        if (cuttingdatalist.cuttingCloths && cuttingdatalist.cuttingCloths.length > 0) {
            const item = cuttingdatalist.cuttingCloths[0];
            setFormData(prev => ({
                ...prev,
                mcloth: item.mcloth,
                mclothNm: item.mclothNm,
                m1cloth: item.m1cloth,
                m1clothNm: item.m1clothNm,
                m2cloth: item.m2cloth,
                m2clothNm: item.m2clothNm,
                m3cloth: item.m3cloth,
                m3clothNm: item.m3clothNm,
                mgmtr: item.mgmtr,
                m1gmtr: item.m1gmtr,
                m2gmtr: item.m2gmtr,
                m3gmtr: item.m3gmtr
            }));
        }
    }, [cuttingdatalist]);

    useEffect(() => {
        if (returnQtyValues.length > 0) {
            const reqtytotal = returnQtyValues.reduce((sum, qty) => sum + parseFloat(qty), 0);

            setFormData(prev => ({
                ...prev,
                reQty: reqtytotal || 0,
            }));
        }

    }, [returnQtyValues]);

    // useEffect to update mused whenever returnQtyValues changes
    useEffect(() => {
        if (returnQtyValues.length > 0) {
            const newMusedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const mavg = itemData.mavg !== undefined ? parseFloat(itemData.mavg[index] || 0) : 0;
                return returnQty * mavg;
            });
            const newM1usedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const m1avg = itemData.m1avg !== undefined ? parseFloat(itemData.m1avg[index] || 0) : 0;
                return returnQty * m1avg;
            });

            const newM2usedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const m2avg = itemData.m2avg !== undefined ? parseFloat(itemData.m2avg[index] || 0) : 0;
                return returnQty * m2avg;
            });

            const newM3usedValues = returnQtyValues.map((qty, index) => {
                const returnQty = parseFloat(qty || 0);
                const m3avg = itemData.m3avg !== undefined ? parseFloat(itemData.m3avg[index] || 0) : 0;
                return returnQty * m3avg;
            });

            const totalMused = newMusedValues.reduce((sum, num) => sum + num, 0);
            const totalM1used = newM1usedValues.reduce((sum, num) => sum + num, 0);
            const totalM2used = newM2usedValues.reduce((sum, num) => sum + num, 0);
            const totalM3used = newM3usedValues.reduce((sum, num) => sum + num, 0);

            const mr = parseFloat(formData.mgmtr) - totalMused;
            const m1r = parseFloat(formData.m1gmtr) - totalM1used;
            const m2r = parseFloat(formData.m2gmtr) - totalM2used;
            const m3r = parseFloat(formData.m3gmtr) - totalM3used;
            setFormData((prev) => ({
                ...prev,
                mused: totalMused.toFixed(2), // Update mused automatically
                m1used: totalM1used.toFixed(2),
                m2used: totalM2used.toFixed(2),
                m3used: totalM3used.toFixed(2),
                mRmtr: mr.toFixed(2),
                m1Rmtr: m1r.toFixed(2),
                m2Rmtr: m2r.toFixed(2),
                m3Rmtr: m3r.toFixed(2)
            }));
        }

    }, [returnQtyValues, itemData]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };
    const handleRemainChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'mRmtr':
                let main_used = parseInt(formData.mgmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    mused: main_used,
                    mRmtr: value
                }));
                break;
            case 'm1Rmtr':
                let m1_used = parseInt(formData.m1gmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    m1used: m1_used,
                    m1Rmtr: value
                }));
                break;
            case 'm2Rmtr':
                let m2_used = parseInt(formData.m2gmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    m2used: m2_used,
                    m2Rmtr: value
                }));
                break;
            case 'm3Rmtr':
                let m3_used = parseInt(formData.m3gmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    m3used: m3_used,
                    m3Rmtr: value
                }));
                break;
            default:
                break;
        }
    }

    const handleQtyChange = (type, index, value) => {
        // Allow only numeric values
        if (/^\d*$/.test(value)) {
            let updatedValues;
            switch (type) {
                case 'return':
                    updatedValues = [...returnQtyValues];
                    updatedValues[index] = value;
                    setReturnQtyValues(updatedValues);

                    if (value > itemData.qty[index]) {
                        // Case 2: returnQty > cuttingQty
                        let extraQty = [...extraQtyValues];
                        extraQty[index] = value - itemData.qty[index];
                        setExtraQtyValues(extraQty);
                        setBalQtyValues(prev => {
                            let balQty = [...prev];
                            balQty[index] = 0; // If returnQty > cuttingQty, balQty is 0
                            return balQty;
                        });
                    } else {
                        // Case 1: returnQty <= cuttingQty
                        setBalQtyValues(prev => {
                            let balQty = [...prev];
                            balQty[index] = itemData.qty[index] - value;
                            return balQty;
                        });
                        setExtraQtyValues(prev => {
                            let extraQty = [...prev];
                            extraQty[index] = 0; // If returnQty <= cuttingQty, extraQty is 0
                            return extraQty;
                        });
                    }
                    let main_avg = [...mainAvg];
                    let singleUsed = parseFloat(itemData.qty[index]) * parseFloat(itemData.mavg[index]);
                    let mact_avg = parseFloat(singleUsed.toFixed(2)) / parseFloat(value);
                    main_avg[index] = mact_avg.toFixed(2);
                    setMainAvg(main_avg);

                    let m1_avg = [...m1Avg];
                    let m1single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m1avg[index]);
                    let m1actual_avg = parseFloat(m1single.toFixed(2)) / parseFloat(value);
                    m1_avg[index] = m1actual_avg.toFixed(2);
                    setM1Avg(m1_avg);

                    let m2_avg = [...m2Avg];
                    let m2single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m2avg[index]);
                    let m2actual_avg = parseFloat(m2single.toFixed(2)) / parseFloat(value);
                    m2_avg[index] = m2actual_avg.toFixed(2);
                    setM2Avg(m2_avg);

                    let m3_avg = [...m3Avg];
                    let m3single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m3avg[index]);
                    let m3actual_avg = parseFloat(m3single.toFixed(2)) / parseFloat(value);
                    m3_avg[index] = m3actual_avg.toFixed(2);
                    setM3Avg(m3_avg);

                    // if (formData.mused || formData.m1used || formData.m2used || formData.m3used) {
                    //     let returnQty = [...updatedValues];

                    //     // Update mainAvg
                    //     let main_avg = [...mainAvg];
                    //     let mActual_avg = parseFloat(formData.mused) / parseFloat(returnQty[index]);
                    //     main_avg[index] = mActual_avg.toFixed(2);
                    //     setMainAvg(main_avg);

                    //     // Update m1Avg
                    //     let m1_avg = [...m1Avg];
                    //     let m1actual_avg = parseFloat(formData.m1used) / parseFloat(returnQty[index]);
                    //     m1_avg[index] = m1actual_avg.toFixed(2);
                    //     setM1Avg(m1_avg);

                    //     // Update m2Avg
                    //     let m2_avg = [...m2Avg];
                    //     let m2actual_avg = parseFloat(formData.m2used) / parseFloat(returnQty[index]);
                    //     m2_avg[index] = m2actual_avg.toFixed(2);
                    //     setM2Avg(m2_avg);

                    //     // Update m3Avg
                    //     let m3_avg = [...m3Avg];
                    //     let m3actual_avg = parseFloat(formData.m3used) / parseFloat(returnQty[index]);
                    //     m3_avg[index] = m3actual_avg.toFixed(2);
                    //     setM3Avg(m3_avg);
                    // } else {
                    //     alert('Enter the value of Remain Mtr');
                    // }
                    // Update mused calculation properly


                    break;

                case 'damage':
                    updatedValues = [...damageQtyValues];
                    updatedValues[index] = value;
                    setDamageQtyValues(updatedValues);

                    // Adjusting the `returnQty` when `damageQty` is entered
                    let currentReturnQty = returnQtyValues[index] || 0;
                    let damageQty = parseInt(value) || 0;
                    let cuttingQty = itemData.qty[index];

                    if (currentReturnQty >= cuttingQty) {
                        // Case when returnQty is already greater than cuttingQty
                        let extraQty = [...extraQtyValues];
                        let excessReturn = currentReturnQty - damageQty - cuttingQty;
                        extraQty[index] = excessReturn >= 0 ? excessReturn : 0; // Handle extraQty
                        setExtraQtyValues(extraQty);

                        setBalQtyValues(prev => {
                            let balQty = [...prev];
                            balQty[index] = 0; // BalQty is zero when returnQty > cuttingQty
                            return balQty;
                        });
                        let returnQty = [...returnQtyValues];
                        let updatereturn = currentReturnQty - damageQty;
                        returnQty[index] = updatereturn >= 0 ? updatereturn : 0;
                        setReturnQtyValues(returnQty);

                        let main_avg = [...mainAvg];
                        let singleUsed = parseFloat(itemData.qty[index]) * parseFloat(itemData.mavg[index]);
                        let mact_avg = parseFloat(singleUsed.toFixed(2)) / parseFloat(returnQty[index]);
                        main_avg[index] = mact_avg.toFixed(2);
                        setMainAvg(main_avg);

                        let m1_avg = [...m1Avg];
                        let m1single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m1avg[index]);
                        let m1actual_avg = parseFloat(m1single.toFixed(2)) / parseFloat(returnQty[index]);
                        m1_avg[index] = m1actual_avg.toFixed(2);
                        setM1Avg(m1_avg);

                        let m2_avg = [...m2Avg];
                        let m2single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m2avg[index]);
                        let m2actual_avg = parseFloat(m2single.toFixed(2)) / parseFloat(returnQty[index]);
                        m2_avg[index] = m2actual_avg.toFixed(2);
                        setM2Avg(m2_avg);

                        let m3_avg = [...m3Avg];
                        let m3single = parseFloat(itemData.qty[index]) * parseFloat(itemData.m3avg[index]);
                        let m3actual_avg = parseFloat(m3single.toFixed(2)) / parseFloat(returnQty[index]);
                        m3_avg[index] = m3actual_avg.toFixed(2);
                        setM3Avg(m3_avg);
                        // if (formData.mused || formData.m1used || formData.m2used || formData.m3used) {


                        //     // Update mainAvg
                        //     let main_avg = [...mainAvg];
                        //     let mActual_avg = parseFloat(formData.mused) / parseFloat(updatereturn);
                        //     main_avg[index] = mActual_avg.toFixed(2);
                        //     setMainAvg(main_avg);

                        //     // Update m1Avg
                        //     let m1_avg = [...m1Avg];
                        //     let m1actual_avg = parseFloat(formData.m1used) / parseFloat(updatereturn);
                        //     m1_avg[index] = m1actual_avg.toFixed(2);
                        //     setM1Avg(m1_avg);

                        //     // Update m2Avg
                        //     let m2_avg = [...m2Avg];
                        //     let m2actual_avg = parseFloat(formData.m2used) / parseFloat(updatereturn);
                        //     m2_avg[index] = m2actual_avg.toFixed(2);
                        //     setM2Avg(m2_avg);

                        //     // Update m3Avg
                        //     let m3_avg = [...m3Avg];
                        //     let m3actual_avg = parseFloat(formData.m3used) / parseFloat(updatereturn);
                        //     m3_avg[index] = m3actual_avg.toFixed(2);
                        //     setM3Avg(m3_avg);
                        // } else {
                        //     alert('Enter the value of Remain Mtr');
                        // }
                    } else {
                        // Normal case: when returnQty <= cuttingQty
                        let remainingQty = cuttingQty - currentReturnQty;
                        let balQty = remainingQty - damageQty;

                        setBalQtyValues(prev => {
                            let newBalQty = [...prev];
                            newBalQty[index] = balQty >= 0 ? balQty : 0; // Ensure no negative balQty
                            return newBalQty;
                        });

                        setExtraQtyValues(prev => {
                            let newExtraQty = [...prev];
                            newExtraQty[index] = 0; // ExtraQty is 0 when returnQty <= cuttingQty
                            return newExtraQty;
                        });
                    }



                    break;

                default:
                    break;
            }

        }
    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };



    function convertIntoOneObject(formData, itemData, extraQtyValues, returnQtyValues, damageQtyValues, balQtyValues, mainAvg, m1Avg, m2Avg, m3Avg) {
        const data = {
            dt: formData.dt,
            reMemo: formData.reMemo,
            cutMemo: formData.cutMemo,
            empId: formData.empId,
            empType: formData.empType,
            cutId: formData.cutId,
            itemId: formData.itemId,
            soId: formData.soId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth || '0',
            m2cloth: formData.m2cloth || '0',
            m3cloth: formData.m3cloth || '0',
            mused: formData.mused,
            m1used: formData.m1used || '0',
            m2used: formData.m2used || '0',
            m3used: formData.m3used || '0',
            totQty: formData.totQty || '0',
            reQty: formData.reQty || '0',
            size: itemData.size,
            mavg: mainAvg,
            m1avg: m1Avg,
            m2avg: m2Avg,
            m3avg: m3Avg,
            cqty: itemData.qty,
            eqty: extraQtyValues,
            rqty: returnQtyValues,
            dqty: damageQtyValues,
            balqty: balQtyValues,
            userId: formData.userId,
        }
        return data;
    }
    const fields = [
        { label: 'Cutting Memo', name: 'cutMemo' },
        { label: 'Master', name: 'empNm' },
        { label: 'Item', name: 'item' },
    ];

    const fields2 = [
        { label: 'Main Cloth', name: 'mclothNm' },
    ];
    const validate = () => {
        const newErrors = {};
        if (!formData.firm) newErrors.firm = 'firm is required';
        if (!formData.challanNo) newErrors.challanNo = 'challanNo is required';
        if (!formData.sono) newErrors.sono = 'Sale Order No is required';
        if (!formData.category) newErrors.category = 'category is required';
        if (!formData.empNm) newErrors.empNm = 'empNm is required';
        if (!formData.totMtr) newErrors.totMtr = 'totMtr is required';
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        const finalObject = convertIntoOneObject(formData, itemData, extraQtyValues, returnQtyValues, damageQtyValues, balQtyValues, mainAvg, m1Avg, m2Avg, m3Avg);

        dispatch(cuttingReturnEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Cutting Return Added");
                alert("Cutting Return Added");
                window.close();
                // if (window.confirm("Your data has been submitted successfully. Do you want to close this tab?")) {
                //     window.close();
                // }

            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });


    };

    return (
        <>

            <div style={{ margin: '1% 1%' }}>
                <h2>Cutting Return Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Return Memo', name: 'reMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {formData.soId !== '0' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='sono'>Sale Order No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='sono'

                                                    >
                                                        {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {fields.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id={field.name}
                                                    >
                                                        {formData[field.name] || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='totQty'>Issue Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='totQty'

                                                >
                                                    {formData.totQty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='reQty'>Return Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='reQty'

                                                >
                                                    {formData.reQty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {formData.soId === '0' &&

                                    <Grid item xs={12} md={6}>

                                    </Grid>

                                }
                                {fields2.map((field) => (
                                    <Grid item xs={12} md={4.5} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id={field.name}
                                                    >
                                                        {formData[field.name] || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={2.2}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mgmtr'>Given Main Mtr.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mgmtr'

                                                >
                                                    {formData.mgmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={2.2}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mused'>Used Main Mtr.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mused'

                                                >
                                                    {formData.mused || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={2.6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mRmtr'>Remain Main Mtr.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mRmtr'

                                                >
                                                    {formData.mRmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {formData.m1cloth !== '0' &&
                                    <>
                                        <Grid item xs={12} md={4.5}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1clothNm'>M-1 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1clothNm'

                                                        >
                                                            {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>
                                                        {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1gmtr'>Given M-1 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1gmtr'

                                                        >
                                                            {formData.m1gmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1used'>Used M-1 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1used'

                                                        >
                                                            {formData.m1used || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* <Grid item xs={12} md={2.6} sx={{ mt: -0.3 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1Rmtr'>Remain M-1 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            id='m1Rmtr'
                                                            name='m1Rmtr'
                                                            value={formData.m1Rmtr || ''}
                                                            onChange={handleInputChange}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                                    handleRemainChange(e);
                                                                }
                                                            }}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbersmall}
                                                        />
                                                        {errors.m1Rmtr && <FormHelperText style={errorStyles}>{errors.m1Rmtr}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid> */}
                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1Rmtr'>Remain M-1 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1Rmtr'

                                                        >
                                                            {formData.m1Rmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>

                                }


                                {formData.m2cloth !== '0' &&

                                    <>
                                        <Grid item xs={12} md={4.5}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2clothNm'>M-2 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2clothNm'

                                                        >
                                                            {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>
                                                        {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2gmtr'>Given M-2 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2gmtr'

                                                        >
                                                            {formData.m2gmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2used'>Used M-2 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2used'

                                                        >
                                                            {formData.m2used || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* <Grid item xs={12} md={2.6} sx={{ mt: -0.3 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2Rmtr'>Remain M-2 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            id='m2Rmtr'
                                                            name='m2Rmtr'
                                                            value={formData.m2Rmtr || ''}
                                                            onChange={handleInputChange}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                                    handleRemainChange(e);
                                                                }
                                                            }}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbersmall}
                                                        />
                                                        {errors.m2Rmtr && <FormHelperText style={errorStyles}>{errors.m2Rmtr}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid> */}

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2Rmtr'>Remain M-2 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2Rmtr'

                                                        >
                                                            {formData.m2Rmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>

                                }


                                {formData.m3cloth !== '0' &&

                                    <>
                                        <Grid item xs={12} md={4.5}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3clothNm'>M-3 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3clothNm'

                                                        >
                                                            {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3gmtr'>Given M-3 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3gmtr'

                                                        >
                                                            {formData.m3gmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3used'>Used M-3 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3used'

                                                        >
                                                            {formData.m3used || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* <Grid item xs={12} md={2.6} sx={{ mt: -0.3 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3Rmtr'>Remain M-3 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            id='m3Rmtr'
                                                            name='m3Rmtr'
                                                            value={formData.m3Rmtr || ''}
                                                            onChange={handleInputChange}
                                                            onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                                    handleRemainChange(e);
                                                                }
                                                            }}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbersmall}
                                                        />
                                                        {errors.m3Rmtr && <FormHelperText style={errorStyles}>{errors.m3Rmtr}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid> */}

                                        <Grid item xs={12} md={2.2}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '60%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3Rmtr'>Remain M-3 Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3Rmtr'

                                                        >
                                                            {formData.m3Rmtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>

                                }



                                {formData.cutMemo !== '' &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Cutting Qty.</TableCell>
                                                    {itemData.qty ? itemData.qty.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                        <>
                                                            Main Avg. <br /> <hr /> Main Actual Avg.
                                                        </>
                                                    </TableCell>
                                                    {itemData.mavg ? itemData.mavg.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <>
                                                                {val} <br /> <hr /> {!mainAvg[index] ? 0 : (val >= mainAvg[index] ? <p style={{ color: 'green' }}>{mainAvg[index]}</p> : <p style={{ color: 'red' }}>{mainAvg[index]}</p>)}
                                                            </>
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {formData.m1cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                            <>
                                                                M1 Avg. <br /> <hr /> M1 Actual Avg.
                                                            </>
                                                        </TableCell>
                                                        {itemData.m1avg ? itemData.m1avg.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <>
                                                                    {val} <br /> <hr />{!m1Avg[index] ? 0 : (val >= m1Avg[index] ? <p style={{ color: 'green' }}>{m1Avg[index]}</p> : <p style={{ color: 'red' }}>{m1Avg[index]}</p>)}
                                                                </>
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                {formData.m2cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                            <>
                                                                M2 Avg. <br /> <hr /> M2 Actual Avg.
                                                            </>
                                                        </TableCell>
                                                        {itemData.m2avg ? itemData.m2avg.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <>
                                                                    {val} <br /> <hr />{!m2Avg[index] ? 0 : (val >= m2Avg[index] ? <p style={{ color: 'green' }}>{m2Avg[index]}</p> : <p style={{ color: 'red' }}>{m2Avg[index]}</p>)}
                                                                </>
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                {formData.m3cloth !== '0' &&
                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                                                            <>
                                                                M3 Avg. <br /> <hr /> M3 Actual Avg.
                                                            </>
                                                        </TableCell>
                                                        {itemData.m3avg ? itemData.m3avg.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                                <>
                                                                    {val} <br /> <hr />{!m3Avg[index] ? 0 : (val >= m3Avg[index] ? <p style={{ color: 'green' }}>{m3Avg[index]}</p> : <p style={{ color: 'red' }}>{m3Avg[index]}</p>)}
                                                                </>
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>
                                                }

                                                {/* Return Qty Row */}
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={returnQtyValues[index]}
                                                                onChange={(e) => {
                                                                    // Update the value on change
                                                                    const newValues = [...returnQtyValues];
                                                                    newValues[index] = e.target.value;
                                                                    setReturnQtyValues(newValues); // Assuming you have this state setter function
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                        handleQtyChange('return', index, e.target.value);
                                                                    }
                                                                }}

                                                                placeholder='0'
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {/* Damage Qty Row */}
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={damageQtyValues[index]}
                                                                onChange={(e) => {
                                                                    // Update the value on change
                                                                    const newValues = [...damageQtyValues];
                                                                    newValues[index] = e.target.value;
                                                                    setDamageQtyValues(newValues); // Assuming you have this state setter function
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                        handleQtyChange('damage', index, e.target.value);
                                                                    }
                                                                }}

                                                                placeholder='0'
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Extra Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {extraQtyValues[index] || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>



                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {balQtyValues[index] || '0'}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default CuttingInward;
